// extracted by mini-css-extract-plugin
export var addressFields = "_pn-0";
export var animationContainer = "_pn-1";
export var footer = "_pn-2";
export var lineItems = "_pn-3";
export var modalContent = "_pn-4";
export var orderName = "_pn-5";
export var strong = "_pn-6";
export var warning = "_pn-7";